import { Component, OnInit } from '@angular/core';

import { Location } from '@angular/common';

import { NotificationService } from 'src/app/Service/notification.service';

import { FormGroup, FormBuilder, FormControl, NgForm } from '@angular/forms';

import axios from 'src/app/Service/axios';

import { Observable, map, of, startWith } from 'rxjs';

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from 'src/app/Service/gurd-service.service';

import { OtherService } from 'src/app/Service/other.service';

import { Router } from '@angular/router';

import * as moment from 'moment-jalaali'

import { DataService } from 'src/app/Service/data.service';

declare let $: any;

@Component({

  selector: 'app-route-schedule',

  templateUrl: './route-schedule.component.html',

  styleUrls: ['./route-schedule.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class RouteScheduleComponent implements OnInit {

  list_Route: any = [];

  list_Result: any = [];

  list_Search: any = [];

  list_BusLine: any = [];

  list_RouteStatus: any = [];

  list_Car: any = [];

  filteredRoute = [];

  filteredCar = [];

  access: any = [];

  lstRoute_Schdeule: any = [];

  editMode: boolean = false;

  bResult: boolean = false;

  showFilter: boolean = false;

  RouteResult_Model: any = {};

  searchModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iRoute: new FormControl(-1),

    strSDate: new FormControl(moment().format('jYYYY/jMM/jDD')),

    strEDate: new FormControl(moment().format('jYYYY/jMM/jDD')),

  })

  scheduleModel: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(window.localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iRoute: new FormControl(-1),

    strRoute: new FormControl(""),

    strUnitID: new FormControl(-1),

    strFullName: new FormControl(""),

    strDate: new FormControl(""),

    strSDate: new FormControl(""),

    strEDate: new FormControl(""),

    strSTime: new FormControl(""),

    strETime: new FormControl(""),

    strComment: new FormControl(""),

    iRoute_Schdeule: new FormControl(""),

    index: new FormControl(""),

  })

  constructor(

    private location: Location,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private router: Router,

    private dataService: DataService,


  ) { }

  ngOnInit(): void {

    this.access = JSON.parse(this.gurdService.decrypt(localStorage.getItem('menu') as string)!);

    // this.access.bRoute_Route_Schdeule_Delete = false;

    // this.access.bRoute_Route_Schdeule_Save = false;

    // this.access.bRoute_Route_Schdeule_Edit = false;

    this.get_Route();

    this.getCarList();

    this.get_Result();

    //timePicker

    $('.clockpicker').clockpicker({

      donetext: 'top',

      align: 'top',

      autoclose: true,

    });

  }

  filter_Route() {

    if (this.scheduleModel.get('strRoute')?.value == '') {

      this.filteredRoute = this.list_Route;

      this.scheduleModel.controls['iRoute'].setValue(-1);

    }

    else this.filteredRoute = this.list_Route.filter((item: any) => item.strName.includes(this.scheduleModel.get('strRoute')?.value));

  }

  filter_Car() {

    if (this.scheduleModel.get('strFullName')?.value == '') {

      this.filteredCar = this.list_Car;

      this.scheduleModel.controls['strUnitID'].setValue(-1);

    }

    else this.filteredCar = this.list_Car.filter((item: any) => item.strFullName.includes(this.scheduleModel.get('strFullName')?.value));

  }

  choose_Route(item: any) {

    this.scheduleModel.controls['iRoute'].setValue(item.iRoute);

    this.scheduleModel.controls['strRoute'].setValue(item.strName);

    this.filteredRoute = [];


  }

  choose_Car(item: any) {

    this.scheduleModel.controls['strUnitID'].setValue(item.strUnitID);

    this.scheduleModel.controls['strFullName'].setValue(item.strFullName);

    this.filteredCar = [];


  }

  hideRouteOptions() {

    setTimeout(() => {

      this.filteredRoute = [];

    }, 100);
  }

  hideCarOptions() {

    setTimeout(() => {

      this.filteredCar = [];

    }, 100);
  }

  new_Schedule() {

    this.scheduleModel.patchValue({

      strRoute: "",

      iRoute: "",

      strFullName: "",

      strUnitID: "",

      strDate: "",

      strSDate: "",

      strEDate: "",

      strSTime: "",

      strETime: "",

      strComment: "",

    })

    // Rerender custom-filter

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);

    this.editMode = false;

    $("#schedule-modal").modal("show");

  }

  editModal(item: any, index: number) {

    Object.keys(item).forEach(key => {

      this.scheduleModel.get(key)?.setValue(item[key])

    })

    this.scheduleModel.controls['strRoute'].setValue(item.strName);

    this.scheduleModel.controls['strFullName'].setValue(item.strFullName);

    this.scheduleModel.controls['index'].setValue(index);

    // Rerender custom-filter

    this.showFilter = false;

    setTimeout(() => {

      this.showFilter = true;

    }, 10);


    this.editMode = true;

    $("#schedule-modal").modal("show");

  }

  get_Route = async () => {

    var model = {

      strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    };

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_List`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Route = res;

  }

  get_Result = async () => {

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Schdeule_Search`, { ...this.searchModel.value });

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    this.list_Result = res;

    this.list_Search = res;

  }

  getCarList = async () => {

    // var model = {

    //   ID: this.gurdService.decrypt(localStorage.getItem('ID')!),

    //   strUnitID: this.gurdService.decrypt(localStorage.getItem('UnitID')!),

    //   strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    //   bFromWeb: true

    // };

    // this.otherService.Showspinner();

    // const resp = await axios.post(`Radyab_GetAllCar?strSession=${this.gurdService.decrypt(localStorage.getItem('Session')!)}`, model);

    // this.otherService.nonespinner();

    // if (resp.data == null) return this.Notification.showError('بروز خطا در سامانه');

    // if (resp.data[0].ISSessionExpired == true) {

    //   this.otherService.removeLocalStorage();

    //   return this.router.navigate(['/']);

    // }

    // this.list_Car = resp.data;

    //? دریافت لیست خودروها بدون تصویر

    if (!this.dataService.carList_New) {

      this.dataService.getCarList_New().then((resp: any) => {

        this.list_Car = this.dataService.carList_New;

      });

    }

    else {

      this.list_Car = this.dataService.carList_New;

    }


    // strFullName

  }

  save_Schedule = async () => {

    var model = this.scheduleModel.value;

    model.strSTime = (document.getElementById("strSTime") as any).value;

    model.strETime = (document.getElementById("strETime") as any).value;

    if (model.strUnitID == -1 || model.strUnitID.trim() == '') {

      return this.Notification.showError('لطفا متحرک را مشخص کنید');

    }

    if (model.iRoute == -1 || model.iRoute.toString().trim() == '') {

      return this.Notification.showError('لطفا مسیر را مشخص کنید');

    }

    if (model.strSTime == "" || model.strETime == "" || model.strSDate == "" || model.strEDate == "") {

      return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Schdeule_Save`, model);

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.bError || res.iResult == 0) return this.Notification.showError(res.strError);

    this.list_Result.push(res[0]);

    this.Notification.showSuccess('با موفقیت ثیت شد')

    $("#schedule-modal").modal("hide");

  }

  edit_Schedule = async () => {

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var model = this.scheduleModel.value;

            model.strSTime = (document.getElementById("strSTime") as any).value;
        
            model.strETime = (document.getElementById("strETime") as any).value;

            if (model.iRoute == -1 || model.strUnitID == -1 || model.strSTime == "" || model.strETime == "" || model.strDate == "") return this.Notification.showError('لطفا فرم را با دقت تکمیل کنید');

            this.otherService.Showspinner();

            const resp = await axios.post(`Route_Schdeule_Edit`, model);

            this.otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError) return this.Notification.showError(res.strError);

            this.list_Result[this.scheduleModel.get('index')?.value] = res[0];

            this.Notification.showSuccess('با موفقیت ویرایش شد');

            $("#schedule-modal").modal("hide");


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  delete_Route = async (item: any, index: number) => {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iRoute_Schdeule: item.iRoute_Schdeule

            }

            const resp = await axios.post(`Route_Schdeule_Delete`, model);

            let res = JSON.parse(resp.data);

            if (res.bError) return this.Notification.showError(res.strError);

            this.list_Result.splice(index, 1)

            this.Notification.showSuccess("با موفقیت حذف شد");

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  isEditValid(item: any): boolean {

    return (moment(item.strDate.trim(), 'jYYYY/jMM/jDD').isAfter(moment(), 'day') && this.access.bRoute_Route_Schdeule_Edit);

  }

  open_RouteResult_Modal = async (item: any, index: number) => {

    this.RouteResult_Model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iRoute_Schdeule: item.iRoute_Schdeule,

      bResult: item.bDone,

      tiIndex: index

    };

    this.bResult = item.bDone;

    $("#routeResult-modal").modal('show')

  }

  update_RouteStatus = async (bResult: boolean) => {

    this.RouteResult_Model.bResult = bResult;

    this.bResult = bResult;

    this.otherService.Showspinner();

    const resp = await axios.post(`Route_Schdeule_SetResult`, this.RouteResult_Model);

    this.otherService.nonespinner();

    if (resp.data[0].ISSessionExpired == true) {

      this.otherService.removeLocalStorage();

      return this.router.navigate(['/']);

    }

    if (resp.data == null) return this.Notification.showError('بروز خطا در سامانه');

    this.Notification.showSuccess('عملیات با موفقیت انجام شد');

    this.list_Result[this.RouteResult_Model.tiIndex].bDone = this.bResult;

    $("#routeResult-modal").modal('hide');


  }

  markSchedule(value: boolean, item: any) {

    if (value) {

      this.lstRoute_Schdeule.push(item.iRoute_Schdeule);

    }

    if (!value) {

      const index = this.lstRoute_Schdeule.indexOf(item.iRoute_Schdeule);

      if (index > -1) this.lstRoute_Schdeule.splice(index, 1);

    }

  }

  markAllSchedule() {

    if (this.lstRoute_Schdeule.length == this.list_Result.length) {

      this.lstRoute_Schdeule = [];

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند')

    }

    else {

      this.lstRoute_Schdeule = [];

      this.list_Result.forEach((el: any) => {

        this.lstRoute_Schdeule.push(el.iRoute_Schdeule);

      })

      this.Notification.showSuccess('عملیات با موفقیت انتخاب شدند')

    }

  }

  isScheduleSelected(iRoute_Schdeule: number): boolean {

    return this.lstRoute_Schdeule.includes(iRoute_Schdeule)

  }

  removeSchedule_ByGroup = async () => {

    if (!this.lstRoute_Schdeule.length) return this.Notification.showError('لیست انتخابی شما خالی می باشد');

    $.confirm({

      title: `آیا از حذف ${this.lstRoute_Schdeule.length} مورد برنامه ریزی اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              lstiRoute_Schdeule: this.lstRoute_Schdeule

            }

            const resp = await axios.post(`Route_Schdeule_DeleteByList`, model);

            let res = JSON.parse(resp.data);

            if (res.bError) return this.Notification.showError(res.strError);

            this.lstRoute_Schdeule = [];

            this.get_Result();

            this.Notification.showSuccess("با موفقیت حذف شد");

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });


  }

  filter_list(val: any) {

    this.list_Result = this.list_Search.filter((el: any) => {

      return el.strDay.includes(val.value) ||

        el.strFullName.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.list_Result = this.list_Search;

    }

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this.otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }

}
